import React from "react";
import PropTypes from "prop-types";
import { Skeleton as MuiSkeleton } from "@mui/material";

const Skeleton = ({ variant, loading, children, style, ...skeletonProps }) => {
  return loading ? (
    <MuiSkeleton variant={variant} sx={skeletonProps} />
  ) : children ? (
    children
  ) : null;
};

Skeleton.propTypes = {
  loading: PropTypes.bool,
  variant: PropTypes.oneOf(["text", "rect", "circular"]),
  // Styling props that can be passed to the Box container
  style: PropTypes.object
};

Skeleton.defaultProps = {
  variant: "rect",
  loading: true
};

export default Skeleton;
